import { takeLeading, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/agents/actions';
import agentsApi from 'src/services/api/agents';
import toaster from 'src/services/toaster';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* create({ agent }: any) {
  try {
    const response = yield call(agentsApi.create, agent);
    yield put(Creators.agentsCreateRequestSuccess(response));
    toaster.success('agent were added successfully');
  } catch (e) {
    let error = e.response;
    DBErrorMonitor.captureException(e, { saga: 'create', entity: 'agents' });
    handleErrorResponse(error);
    yield put(Creators.agentsCreateRequestError(error));
  }
}

export function* watchCreate() {
  yield takeLeading(Types.AGENTS_CREATE_REQUEST, create);
}

export default watchCreate;
